export const EXECUTION_CONTROL_DOMAIN_KEY = "ExecutionControl";

export const EXECUTION_CONTROL_OVERVIEW_SCREEN_KEY = "/execution-control/command-center/overview/";
export const EXECUTION_CONTROL_OVERVIEW_ROUTE = "/execution-control/command-center/overview";
export const EXECUTION_CONTROL_ROOT_ROUTE = "/execution-control";
export const EXECUTION_CONTROL_POOL_PROFILES_ROUTE = "/execution-control/azure-batch/pool-profiles";
export const EXECUTION_CONTROL_POOL_STATUS_CHECKS_LEGACY_ROUTE = "/execution-control/azure-batch/pool-status-checks";
export const BATCH_MANAGEMENT_LEGACY_SCREEN_KEY = "/batchmanagement/manage/";
export const BATCH_MANAGEMENT_LEGACY_ROUTE = "/batchmanagement/manage";

export const BATCH_MANAGEMENT_TABS = [
  { key: "overview", label: "Overview" },
  { key: "pools", label: "Pools" },
  { key: "active-tasks", label: "Active Tasks" },
  { key: "remote-hosts", label: "Remote Hosts" },
  { key: "background", label: "Background" },
  { key: "scheduled", label: "Scheduled" },
  { key: "tests", label: "Tests" },
  { key: "diagnostics", label: "Diagnostics" },
];

export const EXECUTION_CONTROL_REAL_TABS = [
  { key: "overview", label: "Overview" },
  { key: "connection", label: "Connection" },
  { key: "diagnostics", label: "Diagnostics" },
  { key: "pools", label: "Pool Profiles" },
  { key: "background", label: "Background Events" },
  { key: "scheduled", label: "Scheduled Events" },
  { key: "active-tasks", label: "Azure Batch Work" },
  { key: "tests", label: "Manual Tests" },
];

export const EXECUTION_CONTROL_STUB_TABS = [
  {
    key: "rpc-workers",
    label: "RPC Workers",
    description: "RPC worker lifecycle, capacity, and assignment controls are planned for Phase 2.",
  },
  {
    key: "runtime-hosts",
    label: "Runtime Hosts",
    description: "Provider-neutral runtime host management is planned for Phase 2.",
  },
  {
    key: "routes-capabilities",
    label: "Routes / Capabilities",
    description: "Provider-neutral execution routes and capability management are planned for Phase 2.",
  },
  {
    key: "output-modes",
    label: "Output Modes",
    description: "Execution output mode controls are planned for Phase 2.",
  },
  {
    key: "container-apps",
    label: "Container Apps",
    description: "Container Apps runtime host management is planned for Phase 2.",
  },
  {
    key: "messaging",
    label: "Messaging",
    description: "Service Bus and SSE messaging controls are planned for Phase 2.",
  },
  {
    key: "cost-limits",
    label: "Cost & Limits",
    description: "Execution cost controls, quotas, and limit enforcement views are planned for Phase 2.",
  },
  {
    key: "configuration",
    label: "Configuration",
    description: "Execution-provider configuration management is planned for Phase 2.",
  },
];

export const EXECUTION_CONTROL_SCREENS = [
  {
    key: EXECUTION_CONTROL_OVERVIEW_SCREEN_KEY,
    tabKey: "overview",
    label: "Overview",
    groupLabel: "Command Center",
    routePath: EXECUTION_CONTROL_OVERVIEW_ROUTE,
    description: "Azure Batch health, active task counts, background event counts, pool profile counts, recent failures, and stale processing signals.",
  },
  {
    key: "/execution-control/command-center/connection/",
    tabKey: "connection",
    label: "Connection",
    groupLabel: "Command Center",
    routePath: "/execution-control/command-center/connection",
    description: "Azure Batch account, environment, subscription, and default pool profile connection details.",
  },
  {
    key: "/execution-control/command-center/diagnostics/",
    tabKey: "diagnostics",
    label: "Diagnostics",
    groupLabel: "Command Center",
    routePath: "/execution-control/command-center/diagnostics",
    description: "Operational snapshots, action results, and drill-through details for Azure Batch background processing.",
  },
  {
    key: "/execution-control/azure-batch/pool-profiles/",
    tabKey: "pools",
    label: "Pool Profiles",
    groupLabel: "Command Center",
    routePath: EXECUTION_CONTROL_POOL_PROFILES_ROUTE,
    description: "Azure Batch pool profile inventory with existing create, ensure, and check behavior.",
  },
  {
    key: "/execution-control/background-processing/background-work/",
    tabKey: "background",
    label: "Background Events",
    groupLabel: "Background",
    routePath: "/execution-control/background-processing/background-work",
    description: "Recent and current Azure Batch-backed background events with existing eligible event actions.",
  },
  {
    key: "/execution-control/background-processing/scheduled-work/",
    tabKey: "scheduled",
    label: "Scheduled Events",
    groupLabel: "Background",
    routePath: "/execution-control/background-processing/scheduled-work",
    description: "Scheduled background events with run, pause, resume, cancel, reschedule, and Event panel actions where supported.",
  },
  {
    key: "/execution-control/azure-batch/batch-resources/",
    tabKey: "active-tasks",
    label: "Azure Batch Work",
    groupLabel: "Background",
    routePath: "/execution-control/azure-batch/batch-resources",
    description: "Azure Batch-backed background work with linked events, jobs, and tasks.",
  },
  {
    key: "/execution-control/background-processing/manual-tests/",
    tabKey: "tests",
    label: "Manual Tests",
    groupLabel: "Background",
    routePath: "/execution-control/background-processing/manual-tests",
    description: "Azure Batch-backed manual tests, batch status checks, and pool checks.",
  },
  {
    key: "/execution-control/runtime/rpc-workers/",
    tabKey: "rpc-workers",
    label: "RPC Workers",
    groupLabel: "Runtime",
    routePath: "/execution-control/runtime/rpc-workers",
    description: "RPC worker lifecycle, capacity, and assignment controls are planned for Phase 2.",
    isStub: true,
  },
  {
    key: "/execution-control/runtime/runtime-hosts/",
    tabKey: "runtime-hosts",
    label: "Runtime Hosts",
    groupLabel: "Runtime",
    routePath: "/execution-control/runtime/runtime-hosts",
    description: "Provider-neutral runtime host management is planned for Phase 2.",
    isStub: true,
  },
  {
    key: "/execution-control/runtime/routes-capabilities/",
    tabKey: "routes-capabilities",
    label: "Routes / Capabilities",
    groupLabel: "Runtime",
    routePath: "/execution-control/runtime/routes-capabilities",
    description: "Provider-neutral execution routes and capability management are planned for Phase 2.",
    isStub: true,
  },
  {
    key: "/execution-control/runtime/output-modes/",
    tabKey: "output-modes",
    label: "Output Modes",
    groupLabel: "Runtime",
    routePath: "/execution-control/runtime/output-modes",
    description: "Execution output mode controls are planned for Phase 2.",
    isStub: true,
  },
  {
    key: "/execution-control/platform/container-apps/",
    tabKey: "container-apps",
    label: "Container Apps",
    groupLabel: "Platform",
    routePath: "/execution-control/platform/container-apps",
    description: "Container Apps runtime host management is planned for Phase 2.",
    isStub: true,
  },
  {
    key: "/execution-control/platform/messaging/",
    tabKey: "messaging",
    label: "Messaging",
    groupLabel: "Platform",
    routePath: "/execution-control/platform/messaging",
    description: "Service Bus and SSE messaging controls are planned for Phase 2.",
    isStub: true,
  },
  {
    key: "/execution-control/platform/cost-limits/",
    tabKey: "cost-limits",
    label: "Cost & Limits",
    groupLabel: "Platform",
    routePath: "/execution-control/platform/cost-limits",
    description: "Execution cost controls, quotas, and limit enforcement views are planned for Phase 2.",
    isStub: true,
  },
  {
    key: "/execution-control/platform/configuration/",
    tabKey: "configuration",
    label: "Configuration",
    groupLabel: "Platform",
    routePath: "/execution-control/platform/configuration",
    description: "Execution-provider configuration management is planned for Phase 2.",
    isStub: true,
  },
];

export const EXECUTION_CONTROL_TABS = [
  ...EXECUTION_CONTROL_REAL_TABS,
  ...EXECUTION_CONTROL_STUB_TABS.map((tab) => ({
    ...tab,
    isStub: true,
  })),
];

export const getBatchManagementTabs = () => BATCH_MANAGEMENT_TABS;

export const getExecutionControlTabs = () => EXECUTION_CONTROL_TABS;

export const getExecutionControlScreens = () => EXECUTION_CONTROL_SCREENS;

export const getExecutionControlScreen = (key) =>
  EXECUTION_CONTROL_SCREENS.find((screen) => screen.key === key) ?? null;

export const getExecutionControlScreenByTabKey = (tabKey) =>
  EXECUTION_CONTROL_SCREENS.find((screen) => screen.tabKey === tabKey) ?? null;

export const getExecutionControlStubTab = (key) =>
  EXECUTION_CONTROL_STUB_TABS.find((tab) => tab.key === key) ?? null;

export const isExecutionControlStubTab = (key) => !!getExecutionControlStubTab(key);
